import { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import { actividades, vehiculos } from "../data";
import { Alert, Card, Col, Row, Table } from "react-bootstrap";
import { Chart } from "react-google-charts";

const tableHeaders = [
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
];

const chartOptions = {
  title: "Aumentos desde febrero a octubre",
  legend: { position: "bottom" },
};

const ARSLocale = Intl.NumberFormat("es-AR");

function CalculadoraAumento() {
  const [chartData, setChartData] = useState(null);
  const [modelos, setModelos] = useState([]);
  const [planes, setPlanes] = useState([]);
  const [precios, setPrecios] = useState([]);
  const [sueldos, setSueldos] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [form, setForm] = useState({
    marca: "",
    modelo: "",
    plan: "",
    actividad: "",
  });

  const handleChangeSelect = (e) => {
    setShowTable(false);
    if (e.target.name === "marca") {
      setModelos([]);
      setPlanes([]);
      setPrecios([]);
      setSueldos([]);
      setForm({
        marca: "",
        modelo: "",
        plan: "",
        actividad: "",
      });
      const models = vehiculos.find(
        (vehicle) => vehicle.marca === e.target.value
      ).modelos;
      setModelos((_) => models);
    }
    if (e.target.name === "modelo") {
      setPlanes([]);
      setPrecios([]);
      setSueldos([]);
      const plans = modelos.find(
        (model) => model.nombre === e.target.value
      ).planes;
      setPlanes(plans);
      setForm({
        ...form,
        plan: "",
        actividad: "",
      });
    }
    if (e.target.name === "plan") {
      const planSelected = planes.find(
        (plan) => plan.nombre === e.target.value
      );
      const prices = planSelected.precios;
      setPrecios(prices);
      setSueldos([]);
      setForm({
        ...form,
        actividad: "",
      });
    }
    if (e.target.name === "actividad") {
      const actividadSelected = actividades.find(
        (actividad) => actividad.nombre === e.target.value
      );
      const sueldos = actividadSelected.sueldos;
      setSueldos(sueldos);
    }
    setForm((form) => ({
      ...form,
      [e.target.name]: e.target.value,
    }));
  };

  const handleCheckDisabledSubmit = () => {
    if (form.marca && form.modelo && form.plan && form.actividad) return false;
    return true;
  };

  const handleSubmit = () => {
    setShowTable(true);
    setChartData([
      [
        "Mes",
        "Porcentaje acumulado del vehículo",
        "Porcentaje acumulado del salario",
      ],
      ["febrero", 0, sueldos[0].monto],
      ["octubre", porcentajeAcumuladoVehiculo(), porcentajeAcumuladoSueldo()],
    ]);
  };

  const porcentajeAcumuladoVehiculo = () => {
    let total = 0;
    for (let index = 1; index < precios.length; index++) {
      total += (precios[index].monto / precios[index - 1].monto - 1) * 100;
    }
    return total.toFixed(2);
  };

  const porcentajeAcumuladoSueldo = () => {
    let total = 0;
    for (let index = 0; index < sueldos.length; index++) {
      total += sueldos[index].monto;
    }
    return total.toFixed(2);
  };

  return (
    <Container className="p-4" fluid style={{ maxWidth: 1200 }}>
      <h2>Calculadora de aumentos</h2>
      <Card body style={{ marginBottom: 20 }}>
        <h5>¿Qué tenés que saber del plan de ahorro?</h5>
        <ol>
          <li>
            No estás comprando un auto en cuotas. Pasas a formar parte de un
            grupo con otros adherentes, que también esperan recibir el auto.
          </li>
          <li>
            Cada grupo entrega dos autos por mes: uno por sorteo y uno por
            licitación.
          </li>
          <li>
            Cada cuota se calcula con el precio del auto del mes y se lo divide
            en la cantidad de cuotas. A eso se le suma el 10% de gastos de
            administración.
          </li>
          <li>
            Cuando ingresas, pagas el derecho de suscripción, y cuando ganás el
            sorteo o licitación, pagás el derecho de adjudicación. A veces los
            prorratean, es decir que lo pagarás en cuotas.
          </li>
          <li>
            Desde que tenés el auto, pasas a pagar también el seguro automotor.
          </li>
          <li>
            Si decidís no seguir pagando, lo ideal es avisar a las empresas. El
            dinero que entregaste te lo devolverán recién al terminar el plan, y
            le descontarán una multa del 2 o el 4% según si avisaste o no. Te
            tienen que devolver la cantidad de cuotas que pagaste multiplicado
            por el valor del auto en el último mes.
          </li>
          <li>
            Si el plan es 80/20 quiere decir que pagarás en cuotas el 80% del
            auto, y el 20% lo pagarás cuando ganes el sorteo o la licitación. Si
            el plan es 70/30, pagás el 70% en cuotas y el 30% cuando ganás.
          </li>
        </ol>
      </Card>

      <Alert variant="info">
        <p>
          Los precios de los vehículos utilizados en esta calculadora son
          obtenidos de las páginas oficiales de los distintos planes de ahorro.
        </p>
        <b>Si te cobran un precio mayor</b>, consultanos a través de los canales
        de comunicación que encontraras al final de nuestra página en la seccion "Contactanos"
      </Alert>
      <p className="fs-3">
        Para continuar por favor complete el siguiente formulario
      </p>
      <Form>
        <Row>
          <Col md={6}>
            <Form.Group className="m-2">
              <Form.Label>Marca del vehículo</Form.Label>
              <Form.Select
                name="marca"
                onChange={handleChangeSelect}
                value={form.marca}
              >
                <option disabled value="">
                  Seleccione una marca
                </option>
                {vehiculos.map((vehiculo) => (
                  <option key={vehiculo.marca} value={vehiculo.marca}>
                    {vehiculo.marca}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        {form.marca && (
          <Row>
            <Col md={6}>
              <Form.Group className="m-2">
                <Form.Label>Modelo del vehículo</Form.Label>
                <Form.Select
                  name="modelo"
                  onChange={handleChangeSelect}
                  value={form.modelo}
                >
                  <option disabled value="">
                    Seleccione un modelo
                  </option>
                  {modelos.map((model) => (
                    <option key={model.nombre} value={model.nombre}>
                      {model.nombre}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        )}
        {form.modelo && (
          <Row>
            <Col md={6}>
              <Form.Group className="m-2">
                <Form.Label>Plan del vehículo</Form.Label>
                <Form.Select
                  name="plan"
                  onChange={handleChangeSelect}
                  value={form.plan}
                >
                  <option disabled value="">
                    Seleccione un plan
                  </option>
                  {planes.map((plan) => (
                    <option key={plan.nombre} value={plan.nombre}>
                      {plan.nombre}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        )}
        {form.plan && (
          <Row>
            <Col md={6}>
              <Form.Group className="m-2">
                <Form.Label>Sueldo promedio (Actividad)</Form.Label>
                <Form.Select
                  name="actividad"
                  onChange={handleChangeSelect}
                  value={form.actividad}
                >
                  <option disabled value="">
                    Seleccione su actividad
                  </option>
                  {actividades.map((actividad) => (
                    <option key={actividad.nombre} value={actividad.nombre}>
                      {actividad.nombre}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        )}
        <Button
          className="m-3"
          variant="primary"
          onClick={handleSubmit}
          disabled={handleCheckDisabledSubmit()}
        >
          Calcular
        </Button>
      </Form>
      {showTable && (
        <div>
          <hr className="solid mt-5"></hr>
          <h3>Tabla de progresión de precios</h3>
          <Alert variant="warning">
            <span className="fw-bold">Referencia:</span> Entre paréntesis está
            el porcentaje de cambio de precio del mes. En "sueldo" está cuánto
            aumentó el sueldo promedio
            <hr></hr>
            Los precios de los planes/vehículos son estimativos, los mismos
            deberían coincidir con el valor de mercado
          </Alert>
          <Card body>
            <Table responsive hidden={!showTable} className="mb-1">
              <thead>
                <tr>
                  <th></th>
                  {tableHeaders.map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Vehiculo</td>
                  {precios.map((precio, index) => (
                    <td key={precio.mes}>
                      ${ARSLocale.format(precio.monto)}{" "}
                      {index
                        ? `(${(
                            (precios[index].monto / precios[index - 1].monto -
                              1) *
                            100
                          ).toFixed(2)}%)`
                        : ""}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>Sueldo</td>
                  {sueldos.map((sueldo, index) => (
                    <td key={sueldo.mes}>
                      {sueldo.monto ? sueldo.monto + "%" : "-"}
                    </td>
                  ))}
                </tr>
              </tbody>
            </Table>

            <Alert variant="secondary">
              <p>
                Tu sueldo aumentó el {porcentajeAcumuladoSueldo()}% mientras que
                el vehículo aumentó el {porcentajeAcumuladoVehiculo()}%
              </p>
              <div
                style={{
                  maxWidth: "800px",
                }}
              >
                <Chart
                  chartType="LineChart"
                  width="100%"
                  height="400px"
                  data={chartData}
                  options={chartOptions}
                />
              </div>
            </Alert>
          </Card>
        </div>
      )}
    </Container>
  );
}

export default CalculadoraAumento;
